/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentCommentOutput } from './studentCommentOutput';
import type { HighlightingOutput } from './highlightingOutput';

export interface AUTOGRADERSTUDENTFEEDBACKOutput {
  id?: string;
  studentComment: StudentCommentOutput;
  highlighting: HighlightingOutput;
}
